document.addEventListener('DOMContentLoaded', function () {
  var codeButtons = document.querySelectorAll('.promo-pill__code[data-copy-code]');

  codeButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var code = btn.getAttribute('data-copy-code');
      if (!code) return;

      var copyPromise;
      if (navigator.clipboard && window.isSecureContext) {
        copyPromise = navigator.clipboard.writeText(code);
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          /* no-op */
        }
        document.body.removeChild(textarea);
        copyPromise = Promise.resolve();
      }

      copyPromise
        .then(function () {
          btn.classList.add('is-copied');
          clearTimeout(btn._copyTimeout);
          btn._copyTimeout = setTimeout(function () {
            btn.classList.remove('is-copied');
          }, 1600);
        })
        .catch(function () {
          /* clipboard write failed silently */
        });
    });
  });
});
